import { render, staticRenderFns } from "./NoActiveConversation.vue?vue&type=template&id=769b5bff"
import script from "./NoActiveConversation.vue?vue&type=script&lang=js"
export * from "./NoActiveConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports